<template>
  <div class="pro-banner" v-if="currentAdvSub">

  <div class="pro-bg" :style="{'background-image':'url('+currentAdvSub.preSellCover+')'}">
      <div class="pro-bg-img position-relative">
        <div class="kv-bg">
          <!--<div v-if="currentAdvSub.crowdFunding" class="fenbu w-100 position-absolute">-->
          <!--<img :src="'/static/img/pro/'+currentAdvSub.state+'.png'" alt="" class="w-100">-->
          <!--</div>-->
        </div>
        <div class="video-button t-32" @click="openVideo" v-if="currentAdvSub.helpVideoResource && currentAdvSub.helpVideoResource.url && !isOpen">
          <svg t="1592286045552" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
               p-id="21623" width="48" height="48">
            <path
              d="M711.652513 498.556564l-291.357735-247.878965c-4.19795-3.698194-9.295461-5.397365-14.293021-5.397365-10.794729 0-20.989751 7.49634-20.989751 18.990727v495.857882c0 11.394436 10.195022 18.990727 20.989751 18.990728 4.99756 0 10.095071-1.599219 14.293021-5.397365l291.357735-247.878965c8.495852-7.49634 8.495852-19.790337 0-27.286677z m110.945828 324.541533c-40.380283 40.380283-87.457296 72.064812-139.831723 94.253977-54.073597 22.988775-111.645486 34.583114-171.016496 34.583114s-116.942899-11.594339-171.116447-34.583114c-52.374427-22.089214-99.351489-53.873694-139.831723-94.253977-40.380283-40.380283-72.064812-87.457296-94.253977-139.831723-22.788873-54.073597-34.483163-111.645486-34.483163-171.016496 0-59.37101 11.594339-116.942899 34.583114-171.116447 22.089214-52.374427 53.873694-99.351489 94.253977-139.831723 40.380283-40.380283 87.457296-72.064812 139.831723-94.253977C394.807223 84.258858 452.379112 72.664519 511.750122 72.664519s116.942899 11.594339 171.116447 34.583114c52.374427 22.089214 99.351489 53.873694 139.831723 94.253978 40.380283 40.380283 72.064812 87.457296 94.253977 139.831722 22.788873 54.073597 34.483163 111.645486 34.483163 171.016496 0 59.37101-11.594339 116.942899-34.583114 171.116447-22.189165 52.274475-53.773743 99.251537-94.253977 139.631821zM511.750122 0.499756C229.088141 0.499756 0 229.687848 0 512.249878s229.088141 511.750122 511.750122 511.750122 511.750122-229.088141 511.750122-511.750122S794.412103 0.499756 511.750122 0.499756z"
              p-id="21624" fill="#e3e3e3"></path>
          </svg>
        </div>
        <van-sticky class="z-max" v-if="isOpen">
          <van-overlay :show="isOpen" @click="isOpen = false">
            <div class="shipin-div" id="studyFinish">
              <iframe name="myFrame" class="w-100 h-100 border-0" :src="'/static/videott/index1.html?vid='+ currentAdvSub.helpVideoResource.url"/>
            </div>
          </van-overlay>
        </van-sticky>


        <div class="dotwrapper">
          <div class="qian1 position-absolute" v-if="currentAdvSub.tag && currentAdvSub.tag[1]">
            <div class="dian">
            </div>
            <span class="txt">{{currentAdvSub.tag[1]}}</span>
          </div>
          <div class="qian2 position-absolute" v-if="currentAdvSub.tag && currentAdvSub.tag[0]">
            <div class="dian">
            </div>
            <span class="txt">{{currentAdvSub.tag[0]}}</span>
          </div>
          <div class="qian3 position-absolute" v-if="currentAdvSub.tag && currentAdvSub.tag[3]">
            <div class="dian"></div>
            <span class="txt">{{currentAdvSub.tag[3]}}</span>
          </div>
        </div>

        <div class="top-course pt-83">
          <div class="card">
            <van-card class="card-body">
              <template #title>
                <a href="#" class="color-0d font-16 line-22 d-block van-multi-ellipsis--l2 mb-3">
                  {{currentAdvSub.name}}
                </a>
              </template>
              <template #desc>
                <div class="card-text d-flex" v-if="currentAdvSub.summary">
                  <span class="lantiao"></span>
                  <p class="mb-0 color-33 font-14 text-justify van-multi-ellipsis--l2">
                    {{currentAdvSub.summary}}
                  </p>
                </div>
              </template>
              <template #footer v-if="type==='detail'">
                <div class="desc  pt-1 pb-10 px-3 flex-wrap">
                  <p class="mb-0 color-33 font-12">开放时间<span class="date color-base font-12">
                {{currentAdvSub.learningStartTime|dateFormat('YYYY-MM-DD HH:mm')}} 至 {{currentAdvSub.learningEndTime|dateFormat('YYYY-MM-DD HH:mm')}}</span>
                  </p>
                  <span class="bg-primary px-1 text-white radius-all">{{pState===0?'未开始':pState===1?'进行中':'已结束'}}</span>
                </div>
              </template>
              <template #footer v-else-if="type==='adv'">
                <div class="desc  pt-1 pb-4 px-3" v-if="!currentAdvSub.crowdFunding">
                  <p class="mb-0 color-33 font-12">开放时间<span class="date ml-1 color-base font-12">
                {{currentAdvSub.learningStartTime|dateFormat('YYYY-MM-DD HH:mm')}} 至 {{currentAdvSub.learningEndTime|dateFormat('YYYY-MM-DD HH:mm')}}</span>
                  </p>
                  <!--<van-button class="btn d-flex align-items-center line-13" size="mini">报名</van-button>-->
                </div>
                <div class="bg-white pt-10 pb-3 px-28" v-if="currentAdvSub.crowdFunding">
                  <p class="mb-0 color-88 font-12 line-24 pb-10 border-bottom-e3e3e3 text-justify">
                    <span class="color-0d font-weight-bold">众筹信息：</span>
                    {{currentAdvSub.crowdFundingDesc}}
                  </p>
                  <div class="d-flex align-items-center pt-14">
                    <div class="d-flex w-40 flex-column align-items-center justify-content-center border-right-e3e3e3">
                      <span
                        class="font-weight-bold color-base font-13 mb-12">{{currentAdvSub.crowdFundingFinishCount}}人</span>
                      <p class="mb-0 font-12 color-33">众筹目标</p>
                    </div>
                    <div class="w-60 d-flex flex-column align-items-center justify-content-center ">
                      <span class="font-weight-bold color-base font-13 mb-12">
                        {{currentAdvSub.crowdFundingEndTime|dateFromEnd}}</span>
                      <p class="mb-0 font-12 color-33">{{isEndding?'众筹结束':'众筹进行中'}}</p>
                    </div>
                  </div>
                </div>
              </template>
            </van-card>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Card,Icon,Tabbar, TabbarItem,Button,Overlay,Sticky} from 'vant';
  import {mapState} from "vuex";

  Vue.use(Card);
  Vue.use(Button);
  Vue.use(Tabbar);
  Vue.use(TabbarItem);
  Vue.use(Icon);
  Vue.use(Overlay);
  Vue.use(Sticky);
  export default {
    name: "subBanner",
    data() {
      return {
        isOpen: false,
        playerNew: {},
        rate: 0,
      }
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl
      })
    },
    watch: {
      currentAdvSub: function (newVal, oldVal) {
        if (newVal.crowdFunding) {
          if (newVal.crowdFundingCount == 0 || newVal.crowdFundingFinishCount == 0) {
            this.rate = 0;
          } else {
            this.rate = (newVal.crowdFundingCount / newVal.crowdFundingFinishCount) * 100
          }
        }

        if (newVal.preSellCover) {
          this.currentAdvSub.preSellCover = this.uploadresUrl + newVal.preSellCover
        } else {
          this.currentAdvSub.preSellCover = '/static/img/pro/bg.png'
        }
      }

    },
    props: [
      'currentAdvSub',
      'isEndding',
      'type',
      'finishedRate',
      'pState'
    ],
    mounted() {
      this.$nextTick(()=>{
        let wid = $('.pro-banner').css('width');
        let h = $('.pro-banner').css('height');
        let $style = $('<style type="text/css"></style>');
        $($('head')[0]).append($style);

        let top = wid.slice(0, -2) * 0.75 + 'px'
        let paddingTop = (h.slice(0, -2) - wid.slice(0, -2) * 0.75) + 'px';
        $style.append('.kv-bg {top: ' + top + '; padding-top:' + paddingTop + '}');
      });


    },
    methods: {
      openVideo() {
        this.isOpen = true;
      },
    }
  }
</script>

<style>
  .shipin-div {
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
    height: 13.125rem;
  }
  .pro-banner .van-sticky--fixed {
    z-index: 9999;
  }
  .t-32 {
    top: 32%;
  }
  .pt-83 {
    padding-top: 83%;
  }
  .shuxian {
    width: 1px;
    height: 2.5rem;
    background-color: #e3e3e3;
  }
</style>
